import React from 'react';
import { ProductItemProps } from '../../models/Product';
import ContainerPage from '../../components/ContainerPage';
import HeadTitle from '../../components/HeadTitle';
import { Button } from '../../components';
import { DateSlots, ProductSlots } from './components/ProductSlots';

export type ProductSlotsTemplateProps = {
  productName: string;
  productId: string;
  handleSlot: (slotSelected: DateSlots) => void;

  loadSlotsDates: (date: Date) => Promise<DateSlots[]>;

  loadSlotsHours: (date: Date) => Promise<DateSlots[]>;

  customSlotsHead?: React.ReactNode;

  handleSelectSlot?: (slot: DateSlots) => void;
  goBack?: () => void;
  headTitle?: string;
  serviceName?: string;
  showDates?: boolean;
  loading?: boolean;
  externalDisplayDates?: DateSlots[];
};

export function ProductSlotsTemplate({
  productName,
  productId,
  handleSlot,
  serviceName,
  loadSlotsDates,
  loadSlotsHours,
  customSlotsHead,
  handleSelectSlot,
  headTitle,
  showDates,
  goBack,
  ...rest
}: ProductSlotsTemplateProps) {
  const [slots, setSlots] = React.useState<Record<string, DateSlots>>({});
  const [slotSelected, setSlotSelected] = React.useState<DateSlots>();

  const toggleSlot = (slot?: DateSlots) => {
    if (!slot) {
      delete slots[productId];
    } else {
      slots[productId] = slot;
      handleSelectSlot?.(slot);
    }
    setSlotSelected(slot);
    setSlots({ ...slots });
  };

  const submit = async () => {
    if (slotSelected) handleSlot(slotSelected);
  };

  return (
    <ContainerPage childrenFooter={<Button onClick={submit} disabled={!slotSelected} title={'Continuar'} />}>
      <HeadTitle title={headTitle || 'Data e horário'} goBack={goBack} />

      <div>
        <ProductSlots
          {...rest}
          productName={productName}
          fixed={true}
          visible={true}
          serviceName={serviceName}
          onValueChange={slot => toggleSlot(slot)}
          showScheduleButton={false}
          toggleVisible={() => {}}
          handleWithoutSlots={() => {}}
          loadSlotsDates={loadSlotsDates}
          loadSlotsHours={loadSlotsHours}
          customHeadAccordion={customSlotsHead}
          showDates={showDates}
        />
      </div>
    </ContainerPage>
  );
}
